export default __webpack_public_path__ + "static/greenwin-thumbnail-896e32a0894fe3da52b138b0e40a5dc3-896e32a0894fe3da52b138b0e40a5dc3.jpeg";